export const formatDate = (date?: string, locale = localStorage.i18nextLng || 'en-US') => {
  if (date) {
    return new Date(date).toLocaleDateString(locale);
  }
  return new Date().toLocaleDateString(locale);
};
